'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const theme = {
  heading: {
    h1: 'c-text-editor__theme__h1',
    h2: 'c-text-editor__theme__h2',
    h3: 'c-text-editor__theme__h3',
    h4: 'c-text-editor__theme__h4',
    h5: 'c-text-editor__theme__h5'
  },
  link: 'c-text-editor__theme__link',
  list: {
    listitem: 'c-text-editor__theme__listItem',
    nested: {
      listitem: 'c-text-editor__theme__nestedListItem'
    },
    olDepth: ['c-text-editor__theme__ol1', 'c-text-editor__theme__ol2', 'c-text-editor__theme__ol3', 'c-text-editor__theme__ol4', 'c-text-editor__theme__ol5'],
    ul: 'c-text-editor__theme__ul'
  },
  ltr: 'c-text-editor__theme__ltr',
  rtl: 'c-text-editor__theme__rtl',
  paragraph: 'c-text-editor__theme__paragraph',
  quote: 'c-text-editor__theme__quote',
  table: 'c-text-editor__theme__table',
  tableCell: 'c-text-editor__theme__tableCell',
  tableCellHeader: 'c-text-editor__theme__tableCellHeader',
  text: {
    bold: 'c-text-editor__theme__textBold',
    italic: 'c-text-editor__theme__textItalic',
    strikethrough: 'c-text-editor__theme__textStrikethrough',
    underline: 'c-text-editor__theme__textUnderline',
    underlineStrikethrough: 'c-text-editor__theme__textUnderlineStrikethrough'
  }
};
var _default = exports.default = theme;
